import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { MAX_LARGO_DESCRIPCION } from "../../../utilities/textValidations.js";

const FormCrearTipoProducto = ({
  displayDialog,
  setDisplayDialog,
  descripcion,
  setDescripcion,
  unidad,
  setUnidad,
  tarifa,
  setTarifa,
  unidades,
  nombreEmpresa,
  handleCreateTipoProducto,
  loading,
}) => {
  return (
    <Dialog
      header={`Crear Tipo de Producto ${nombreEmpresa}`}
      visible={displayDialog}
      className="p-fluid product-dialog"
      onHide={() => setDisplayDialog(false)}
      footer={
        <div className="p-d-flex p-jc-end p-mt-3">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            onClick={() => setDisplayDialog(false)}
            className="p-button p-button-rounded p-button-outlined p-mr-2"
          />

          <Button
            label="Guardar"
            icon="pi pi-save"
            onClick={handleCreateTipoProducto}
            className="p-button-success p-button-rounded"
            autoFocus
            disabled={loading || !descripcion || !unidad || !tarifa}
            raised
          />
        </div>
      }
    >
      <div className="p-grid p-formgrid p-fluid">
        <h6 className="mb-3">
            Información
        </h6>

        <span className="p-float-label mt-2 mb-3">
          <InputText
            id="descripcion"
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value.toUpperCase())}
            className="p-inputtext-lg"
            placeholder="Ingrese la descripción del tipo de producto"
            maxLength={MAX_LARGO_DESCRIPCION}
          />
          <label htmlFor="descripcion"><i className="pi pi-tag"></i> Descripción *</label>
        </span>

        <span className="p-float-label mt-2 mb-3">
          <Dropdown
            id="unidad"
            value={unidad}
            options={unidades}
            onChange={(e) => setUnidad(e.value)}
            placeholder="Seleccione una unidad"
            optionLabel="label"
            className="p-inputtext-lg"
          />
          <label htmlFor="unidad"><i className="pi pi-cog"></i> Unidad *</label>
        </span>

        <span className="p-float-label mt-2 mb-3">
          <InputNumber
            id="tarifa"
            value={tarifa}
            onValueChange={(e) => setTarifa(e.value)} // Handle value change
            mode="decimal" // Handle decimal numbers
            minFractionDigits={0} // Set minimum number of decimal digits
            maxFractionDigits={2} // Set maximum number of decimal digits
            placeholder="Ingrese la tarifa en UF"
            className="p-inputtext-lg"
            locale="es-ES" // Set locale to use comma for decimal
            inputMode="decimal" // HTML5 input mode for numeric decima
            min={0.01}
            max={1000}
          />
          <label htmlFor="tarifa"><i className="pi pi-money-bill"></i> Tarifa UF *</label>
        </span>

      </div>
    </Dialog>
  );
};

export default FormCrearTipoProducto;
